import React from 'react';

const LedgerIcon = ({ className = "w-6 h-6", color = "currentColor" }) => {
  return (
    <svg 
      className={className} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Custom L-shaped frame design - similar but legally distinct from Ledger */}
      {/* Top-left L - slightly different proportions */}
      <path 
        d="M2 2 L8 2 L8 4 L4 4 L4 8 L2 8 Z" 
        fill={color}
      />
      
      {/* Top-right L - different corner positioning */}
      <path 
        d="M22 2 L16 2 L16 4 L20 4 L20 8 L22 8 Z" 
        fill={color}
      />
      
      {/* Bottom-left L - modified arm lengths */}
      <path 
        d="M2 22 L8 22 L8 20 L4 20 L4 16 L2 16 Z" 
        fill={color}
      />
      
      {/* Bottom-right L - adjusted proportions */}
      <path 
        d="M22 22 L16 22 L16 20 L20 20 L20 16 L22 16 Z" 
        fill={color}
      />
      
      {/* Center L - different orientation and size */}
      <path 
        d="M10 8 L10 16 L16 16 L16 14 L12 14 L12 8 Z" 
        fill={color}
      />
    </svg>
  );
};

export default LedgerIcon;
